import styled from '@emotion/styled'

import { system } from '../../../theme'

export const Container = styled.div<{ disabled: boolean }>`
  display: flex;
  white-space: nowrap;
  align-items: center;
  padding: 8px 16px;
  column-gap: 8px;
  min-height: 40px;
  opacity: ${({ disabled }) => (disabled ? '0.3' : '1')};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  &:hover {
    background: ${system.colors.neutral50};
  }

  & p {
    padding: 8px 0;
    margin: 0;
  }
`
export const SpacedIconRight = styled.div`
  width: 100%;
  text-align: right;
`
